import axios from "axios";

export const fetchShops = async (params) => {
    return axios
        .get(process.env.REACT_APP_SHOP_API_URL, { params: params.queryKey[1] })
        .then(response => response.data.shoplist)
        .catch(error => console.log(error))
}

export const fetchShopsByBrand = async (params) => {
    return axios
        .get(process.env.REACT_APP_SHOPS_BY_BRAND_API_URL, { params: params.queryKey[1] })
        .then(response => response.data.shoplist)
        .catch(error => console.log(error))
}

